import React, { useState } from 'react';
import MiniPlayer from '../components/MiniPlayer.jsx';
import Code from '../components/Code.jsx';
import { orbsDoc } from '../scenes/minis.js';
import orbsScript from '../scripts/orbs.script.json';
import orbsSource from '../scripts/orbs.ts?raw';

export default function ScriptSection() {
  const [info, setInfo] = useState(null);
  return (
    <section className="sec" id="pulsescript" aria-labelledby="script-h">
      <div className="wrap">
        <header className="sec-head">
          <p className="kicker">PulseScript</p>
          <h2 id="script-h">Interactivity in TypeScript, with a display-list API.</h2>
          <p className="sec-lead">
            MovieClip, Sprite, Graphics, filters, mouse and keyboard events, BEAT and BAR triggers, Timer and
            Tween. <code>pulse compile</code> type-checks the TypeScript and stores sandbox-safe JavaScript in the
            document; the player runs it in a Web Worker with no DOM or network access. Click the stage to
            fire, drag the core, press Space.
          </p>
        </header>
        <div className="split">
          <div className="split-demo">
            <MiniPlayer
              build={(Pulse) => orbsDoc(Pulse, orbsScript)}
              label="PulseScript demo: click to fire glowing orbs from a core that pulses on the beat"
              options={{ scripts: true }}
              onPlayer={(p, Pulse, doc) => setInfo({ valid: Pulse.validate(doc).valid, js: orbsScript.code.length })}
            />
            <p className="demo-cap">
              {info ? `Valid document · script ${(info.js / 1024).toFixed(1)} KiB of compiled JS · 60 Hz logic clock` : 'The scene loads when it scrolls into view.'}
            </p>
          </div>
          <div className="split-code">
            <div className="code-tab"><span>orbs.ts</span><span className="dim">compiled with pulse compile</span></div>
            <Code label="The PulseScript source of the demo" className="code-tall">{orbsSource}</Code>
          </div>
        </div>
      </div>
    </section>
  );
}
